import React from 'react';
import { Loader as SemanticLoader } from 'semantic-ui-react';

import './loader.scss';

export const Loader = ({size="medium"}) => 
    <SemanticLoader size={size} active inline='centered' />

export default Loader;